// Port of api/fuel/app/classes/insights/players/init.php

import Segment from 'offline/insights/segment'
import Constants from 'offline/constants'
import Config from 'offline/model/config'
import Util from 'offline/util'

function monthIndex(ts) {
	var y = parseInt(Util.date('Y', ts), 10)
	var m = parseInt(Util.date('c', ts), 10)
	return ((y - 1970) * 12) + (m - 1)
}

function weekIndex(ts) {
	return Math.floor(dayIndex(ts) / 7)
}

function dayIndex(ts) {
	return Math.floor(ts / Constants.TIME_DAY)
}

function hIndex(plays) {
	if (!plays.length) return 0
	var counts = countValues(plays)
	var values = Object.keys(counts).map(function(key) { return counts[key] }).sort(function(a, b) { return b - a })
	var h = 0
	for (var i = 0; i < values.length; i++) {
		var rank = i + 1
		if (values[i] >= rank) h = rank
		else break
	}
	return h
}

function countValues(values) {
	var counts = {}
	for (var i = 0; i < values.length; i++) {
		var value = values[i]
		if (counts[value] === undefined) counts[value] = 0
		counts[value]++
	}
	return counts
}

export default Segment.extend({
	name: 'init',
	priority: 10,
	types: [Constants.TYPE_USER],
	run: function(type, owner, userIndex, detail, filter) {
		var userId = owner.get_id()
		var config = Config.user(userId)
		var usernames = ((config.plays || {}).usernames || []).slice()
		var playersFilter = (filter && filter.players) ? parseInt(filter.players, 10) : 0
		var range = this.get_period_date_range(type, owner, filter || {})
		var validPlaysIndex = []
		this._data.games = []

		// Raw query rather than Play.collection() to avoid instantiating
		// thousands of Model objects (2,758 plays for nicknelson). Same
		// antipattern fix as size.compare and players.init.
		var playWhereSql = 'user_id = ' + userId +
			' AND play_date >= ' + range.start +
			' AND play_date < ' + range.end
		if (playersFilter) playWhereSql += ' AND play_players = ' + playersFilter

		var playRows = Util.queryFast(
			'SELECT play_id, game_id, play_date, play_length, play_count, play_players' +
			' FROM play WHERE ' + playWhereSql + ' ORDER BY play_date ASC'
		)
		var playIds = []
		var playsRaw = {}
		var gameIdSet = {}

		for (var pi = 0; pi < playRows.length; pi++) {
			var row = playRows[pi]
			var pid = parseInt(row.play_id, 10) || 0
			var gid = parseInt(row.game_id, 10) || 0
			playIds.push(pid)
			playsRaw[pid] = {
				p: pid,
				g: gid,
				d: parseInt(row.play_date, 10) || 0,
				l: parseInt(row.play_length, 10) || 0,
				c: parseInt(row.play_count, 10) || 0,
				pl: parseInt(row.play_players, 10) || 0,
				w: 0
			}
			if (gid) gameIdSet[gid] = true
		}

		if (playIds.length) {
			var gameIdList = Object.keys(gameIdSet).map(function(s) { return parseInt(s, 10) })
			if (gameIdList.length) {
				var weightRows = Util.queryFast(
					'SELECT game_id, game_weight_avg FROM game WHERE game_id IN(' + Util.in(gameIdList) + ')'
				)
				var gameWeightById = {}
				for (var gw = 0; gw < weightRows.length; gw++) {
					gameWeightById[parseInt(weightRows[gw].game_id, 10)] = parseFloat(weightRows[gw].game_weight_avg) || 0
				}
				for (var pw = 0; pw < playIds.length; pw++) {
					var currentPlayId = playIds[pw]
					playsRaw[currentPlayId].w = gameWeightById[playsRaw[currentPlayId].g] || 0
				}
			}
		}

		var playersRaw = playIds.length ? Util.queryFast(
			'SELECT ' +
				'user_id AS u, ' +
				'player_name AS n, ' +
				'play_id AS p, ' +
				'player_win AS w ' +
			'FROM player ' +
			'WHERE play_id IN (' + Util.in(playIds) + ') ' +
			'ORDER BY play_id DESC, rowid ASC'
		) : []

		var players = []
		var playersByID = {}
		var playersByName = {}

		for (var i = 0; i < playersRaw.length; i++) {
			var player = playersRaw[i]
			var id = parseInt(player.u, 10) || 0
			var name = player.n || ''

			if (id !== userId && usernames.indexOf(name) === -1) {
				if (!id && !name) name = 'Unnamed'

				var index = false
				if (id && playersByID[id] !== undefined) index = playersByID[id]
				if (name && index === false && playersByName[name] !== undefined) index = playersByName[name]

				if (index === false) {
					index = players.length
					players.push({
						id: 0,
						slug: '',
						primaryName: '',
						username: '',
						names: {},
						plays: {},
						games: [],
						counts: [],
						totalPlays: 0,
						totalWins: 0,
						totalGames: 0,
						gameFirst: 0,
						gameLast: 0,
						dateFirst: 0,
						dateLast: 0,
						years: [],
						months: [],
						weeks: [],
						days: []
					})
				}

				if (id) playersByID[id] = index
				if (name) playersByName[name] = index
				if (id) players[index].id = id
				if (players[index].names[name] === undefined) players[index].names[name] = 0
				players[index].names[name]++
				players[index].plays[parseInt(player.p, 10)] = parseInt(player.w, 10) || 0
			} else {
				validPlaysIndex.push(parseInt(player.p, 10))
			}
		}

		var validPlaysIndexMap = {}
		for (var vp = 0; vp < validPlaysIndex.length; vp++) validPlaysIndexMap[validPlaysIndex[vp]] = true

		var plays = {}

		for (var p = 0; p < players.length; p++) {
			var playCount = 0
			var durationPlays = 0
			var winCount = 0
			var weightTotal = 0
			var durationTotal = 0
			var games = []

			if (players[p].id) {
				this._references.users.push(parseInt(players[p].id, 10))
			}

			var sortedNames = Object.keys(players[p].names).sort(function(a, b) {
				return players[p].names[b] - players[p].names[a]
			})
			players[p].primaryName = sortedNames[0]
			players[p].slug = Util.slug(Util.englishify(players[p].primaryName))

			var playKeys = Object.keys(players[p].plays)
			for (var pk = 0; pk < playKeys.length; pk++) {
				var playerPlayId = parseInt(playKeys[pk], 10)
				if (!validPlaysIndexMap[playerPlayId] || !playsRaw[playerPlayId]) continue

				if (playsRaw[playerPlayId].l) {
					durationTotal += playsRaw[playerPlayId].l
					durationPlays += playsRaw[playerPlayId].c
				}

				for (var c = 1; c <= playsRaw[playerPlayId].c; c++) {
					players[p].counts.push(playsRaw[playerPlayId].pl)
					games.push(playsRaw[playerPlayId].g)
				}

				if (!plays[playerPlayId]) {
					plays[playerPlayId] = {
						d: playsRaw[playerPlayId].d,
						g: playsRaw[playerPlayId].g,
						pl: playsRaw[playerPlayId].pl,
						c: playsRaw[playerPlayId].c,
						playersIndex: [],
						playersKey: ''
					}
				}

				plays[playerPlayId].playersIndex.push(p)
				playCount += playsRaw[playerPlayId].c
				weightTotal += playsRaw[playerPlayId].w * playsRaw[playerPlayId].c

				if (players[p].plays[playerPlayId]) {
					winCount += playsRaw[playerPlayId].c
					players[p].plays[playerPlayId] = playsRaw[playerPlayId].c
				}

				if (playsRaw[playerPlayId].d > 0) {
					if (!players[p].dateFirst || players[p].dateFirst > playsRaw[playerPlayId].d) {
						players[p].dateFirst = playsRaw[playerPlayId].d
						players[p].gameFirst = playsRaw[playerPlayId].g
					}
					if (!players[p].dateLast || players[p].dateLast < playsRaw[playerPlayId].d) {
						players[p].dateLast = playsRaw[playerPlayId].d
						players[p].gameLast = playsRaw[playerPlayId].g
					}
					players[p].years.push(parseInt(Util.date('Y', playsRaw[playerPlayId].d), 10))
					players[p].months.push(monthIndex(playsRaw[playerPlayId].d))
					players[p].weeks.push(weekIndex(playsRaw[playerPlayId].d))
					players[p].days.push(dayIndex(playsRaw[playerPlayId].d))
				}
			}

			players[p].counts = countValues(players[p].counts)
			players[p].playYears = countValues(players[p].years)
			players[p].years = Array.from(new Set(players[p].years)).sort(function(a, b) { return a - b })
			players[p].months = Array.from(new Set(players[p].months)).sort(function(a, b) { return a - b })
			players[p].weeks = Array.from(new Set(players[p].weeks)).sort(function(a, b) { return a - b })
			players[p].days = Array.from(new Set(players[p].days)).sort(function(a, b) { return a - b })
			players[p].hindex = hIndex(games)
			players[p].gameCounts = countValues(games)
			players[p].games = Array.from(new Set(games))
			players[p].avgWeight = (weightTotal && playCount) ? Math.round((weightTotal / playCount) * 100) / 100 : 0
			players[p].avgDuration = durationPlays ? Math.round((durationTotal / durationPlays) * 100) / 100 : 0
			players[p].totalDuration = durationTotal
			players[p].durationPlays = durationPlays
			players[p].winRatio = playCount ? Math.round(((100 / playCount) * winCount) * 100) / 100 : 0
			players[p].totalPlays = playCount
			players[p].totalWins = winCount
			players[p].totalGames = players[p].games.length

			this._data.games = this._data.games.concat(players[p].games)
		}

		var playIndex = Object.keys(plays)
		for (var j = 0; j < playIndex.length; j++) {
			var playId = playIndex[j]
			plays[playId].playersIndex.sort(function(a, b) { return a - b })
			plays[playId].playersKey = plays[playId].playersIndex.join('-')
		}

		this._data.games = Array.from(new Set(this._data.games))
		this._data.plays = plays
		this._data.players = players

		return {}
	}
})
